import React, { Component } from 'react'
import parse from 'html-react-parser'
import Dropzone from 'react-dropzone'
import { UploadSVG, Close } from './icons'
import { Fade } from 'react-reveal'

const encode = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k)=>{
    formData.append(k,data[k])
  });
  return formData
}

function ContentPreviewFile(props) {
  return (
    <div className='content-preview-image thumbs-container'>
      <div className='thumb'>
        <div className='thumb-inner'>
          <p>{props.files[0].path}</p>
        </div>
      </div>
    </div>
  )
}

const Roles = ({ title, content, roles }) => {
  const [activePost, setActivePost] = React.useState(0)
  const [modal, setModal] = React.useState(false)

  const toggleModal = (i) => {
    setActivePost(i)
    setModal(!modal)
  }

  return (
    <>
      <section className='roles'>
        <Fade bottom distance='40px'>
          <div className='roles__inner'>
            {title && <h2>{title}</h2>}

            <div className='roles__wrapper'>
              <div className='roles__content'>
                {content && parse(content)}
              </div>

              <div className='roles__offers'>
                {roles.title && <h3>{roles.title}</h3>}

                <div className='roles__items'>
                  {roles?.jobs.map((el, index) => {
                    if (el.hide) return null
                    return (
                      <div key={index} className='roles__item'>
                        <div className='roles__title'>
                          {el.position && <h4>{el.position}</h4>}
                          {el.office && <p>{el.office}</p>}
                        </div>

                        <a onClick={(e) => {
                          e.preventDefault()
                          toggleModal(index)
                        }} className='btn btn-straw' href='#'>View Role</a>
                      </div>
                    )
                  })}
                </div>

                <div className='roles__contact'>
                  {roles.footerContent && parse(roles.footerContent)}
                  {roles.footerButton && (
                    <a className='btn btn-blue-steel' href={roles.footerButton.url} onClick={
                      (e) => {
                        e.preventDefault()
                        toggleModal(-1)
                      }
                    }>
                      {roles.footerButton.title}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
      <div className={`modal modal--careers${modal ? ' active' : ''}`}>
        <div className={`modal__close-bg`} onClick={() => setModal(false)}></div>
        <div className='modal__inner'>
          <button className='modal__close' onClick={() => setModal(false)}>
            <Close color='#000000' />
          </button>
          <div className='modal__wrapper'>

            {roles.jobs[activePost] && (
              <div className='modal__content'>
                <h3>{roles.jobs[activePost].position}</h3>
                {parse(roles.jobs[activePost].content)}

                <div className='modal__columns'>
                  <div className='modal__column'>
                    {parse(roles.jobs[activePost].leftCol)}
                  </div>

                  <div className='modal__column'>
                    {parse(roles.jobs[activePost].rightCol)}
                  </div>
                </div>
              </div>
            )}

            <div className='modal__form'>
              <h3>Send us your Resume</h3>
              <CareersForm />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Roles

class CareersForm extends Component {

  state = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    files: [],
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.refs.form.checkValidity()) return false

    fetch("https://hooks.zapier.com/hooks/catch/2181815/3nq7qn4/", {
      method: "POST",
      body: encode({
        "form-name": this.refs.form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => this.setState({result: 'success'}))
      .catch(error => this.setState({result: 'fail', msg: error}))
  }

  onDrop = (files) => {
    this.setState({
      files: files,
      'file_upload': files[0]
    })
  }

  render() {
    let props = {
      ref: 'form',
      name: 'careers',
      className: 'form',
      onSubmit: this.handleSubmit
    };
    if (this.state.result === 'success') {
      return (
        <div className='form__row'>
          <p>Thanks for enquiring. A member of the team will be in touch soon.</p>

        </div>
      )
    }
    let { files } = this.state
    return (
      <form {...props}>
        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label htmlFor='email'>First Name</label>
            <input
              type='text'
              name='first_name'
              required
              onChange={this.handleChange}
            />
          </div>
          <div className='form__item'>
            <label htmlFor='phone'>Last Name</label>
            <input
              type='text'
              name='last_name'
              required
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              name='email'
              required
              onChange={this.handleChange}
            />
          </div>
          <div className='form__item'>
            <label htmlFor='phone'>Contact Number</label>
            <input
              type='text'
              name='phone'
              required
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className='form__row form__row--double form__row--dropzone'>
          <p>Please attach a cover letter and your CV (up to 15MB). Resumes without a cover letter will not be accepted.</p>
          <section className='form__dropzone'>
            <Dropzone onDrop={this.onDrop} multiple={false}>
              {({getRootProps, getInputProps}) => (
                <div  {...getRootProps({className: 'drop-zone__wrapper'})}>
                  {files?.length === 0 &&
                    <>
                      <UploadSVG color='#000000' />
                      <input {...getInputProps()} />
                      <p>Drag and drop your files, or <span>Browse</span></p>
                      <p className='small'>Max 15MB per file</p>
                    </>
                  }
                  { files.length > 0 && files.map((file, i) =>
                    <div key={i}>{file.name} - {file.size} bytes</div>
                  )}
                </div>
              )}
            </Dropzone>
          </section>
        </div>

        <div className='form__row form__row--double form__row--submit'>
          <button className='btn btn-transparent'>
            Clear
          </button>
          <button type='submit' className='btn btn-blue-steel'>
            Send my resume
          </button>
        </div>
      </form>
    );
  }
}